export default __webpack_public_path__ + "static/media/14341 - BigGameJames.7fbcb92d.jpeg";